// V1-COMPAT: this tree was renamed from `companies/` to `companies_v1/` so the
// ported V2 companies components can live at the canonical `companies/` path.
import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import CompaniesSearch from './search';

function TopLevelSearch({
                          query, algoliaAppId, algoliaSearchKey, indexName,
                        }) {
  return (
    <ErrorBoundary>
      <CompaniesSearch
        query={query}
        algoliaAppId={algoliaAppId}
        algoliaSearchKey={algoliaSearchKey}
        indexName={indexName}
      />
    </ErrorBoundary>
  );
}

TopLevelSearch.propTypes = {
  query: PropTypes.string,
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
};

TopLevelSearch.defaultProps = {
  query: '',
};

export default TopLevelSearch;
